

import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Destinations from './components/Destinations';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SuccessModal from './components/SuccessModal';
import FlightModal from './components/FlightModal';
import React, { useState } from 'react';

function App() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showFlight, setShowFlight] = useState(false);

  // Example: open flight modal from Services (to be wired up)
  // Pass setShowFlight to Services if you want to trigger modal from button

  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <Destinations />
      <About />
      <Contact />
      <Footer />
      <SuccessModal show={showSuccess} onClose={() => setShowSuccess(false)} />
      <FlightModal show={showFlight} onClose={() => setShowFlight(false)} />
    </div>
  );
}

export default App;
